var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPronosticoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-64c10236-1544-4a63-aa87-856e44d3229e",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-9cc4b8d4-ef01-499c-bb34-41adb99d3d12",
    d: "M932.89,97.76h-34.14v-48.62c0-27.1-21.99-49.14-49.09-49.14s-49.09,22.04-49.09,49.14v48.62H277.17v-48.62c0-27.1-21.99-49.14-49.09-49.14s-49.09,22.04-49.09,49.14v48.62h-31.87c-54.26,0-98.23,43.98-98.23,98.23v785.77c0,54.26,43.98,98.23,98.23,98.23h785.77c54.26,0,98.23-43.98,98.23-98.23V195.99c0-54.26-43.98-98.23-98.23-98.23ZM932.89,981.77H147.11V447.04h785.77v534.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-9cc4b8d4-ef01-499c-bb34-41adb99d3d12",
    d: "M761.57,922.02c54.23,0,98.21-43.98,98.21-98.18s-43.98-98.23-98.21-98.23-98.23,43.98-98.23,98.23,43.98,98.18,98.23,98.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPronosticoIcon);
export default __webpack_public_path__ + "static/media/PronosticoIcon.45427154ca4f82c8214cb19c6997daa6.svg";
export { ForwardRef as ReactComponent };